import React from 'react';

import {
  Wrapper,
  NewWrapper,
  NewText,
  Overline,
  Title,
  Text,
  More,
  Link,
} from './elements';

type Props = {
  readonly className?: string;
  readonly backgroundColor?: string;
  readonly recentlyAdded?: boolean;
  readonly newText?: string;
  readonly newColor?: string;
  readonly overlineText: string;
  readonly title: string;
  readonly text?: string;
  readonly learnMoreText?: string;
  readonly onClick?: () => void;
  readonly href?: string;
  readonly hrefText?: string;
};

function DidYouKnow({
  className,
  backgroundColor,
  recentlyAdded,
  newText,
  newColor,
  overlineText,
  title,
  text,
  learnMoreText,
  href,
  hrefText,
  onClick,
}: Props): React.ReactElement {
  return (
    <Wrapper onClick={onClick} className={className} color={backgroundColor}>
      {recentlyAdded && (
        <NewWrapper color={newColor}>
          <NewText>{newText}</NewText>
        </NewWrapper>
      )}
      <Overline>{overlineText}</Overline>
      <Title>{title}</Title>
      {text && <Text>{text}</Text>}
      {learnMoreText && <More>{learnMoreText}</More>}
      {href && (
        <Link href={href} target={'_blank'}>
          {hrefText}
        </Link>
      )}
    </Wrapper>
  );
}

export default DidYouKnow;
